import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { LogTrackingService } from '../log-tracking.service';
import { ColDef, ExcelExportParams, UseGroupTotalRow, GridApi, GridReadyEvent } from 'ag-grid-community';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { LogTrackDialogComponent } from '../log-track-dialog/log-track-dialog.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { NgxSpinnerService } from 'ngx-spinner';


// export interface TableElement2 {
//   headName: string;
//   strength: number;
//   totalFee: number;
//   netFee: number;
//   feePaid: number;
//   dueAmount: number;
//   avgPaid: number;
//   avgNet: number;
//   duePercentage: number;
// }

export interface LogTrack {
  brandName: string;
  UserName: string;
  module: string;
  VisitDateTime: string;
  appType: string;
  appVersion: string;
  eventType: string;
  deviceModel: string;
  eventMessage: string;
  platform: string;
  platformVersion: string;
  UserId: string;
}

@Component({
  selector: 'app-log-tracking-landing',
  templateUrl: './log-tracking-landing.component.html',
  styleUrls: ['./log-tracking-landing.component.scss']
})

export class LogTrackingLandingComponent implements OnInit {
  gridApi: GridApi<any>;
  gridColumnApi: any;
  trackList: any;
  lastFourDigits: string = '';
  searchFilterList: any;

  constructor(private http: HttpClient, private log: LogTrackingService, private dialog: NgDialogAnimationService, private spinner: NgxSpinnerService) { }


  ngOnInit(): void {
    this.logTrack();
  }


  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit(); // Example of using the API
  }



  rowGroupPanelShow: "always" | "onlyWhenGrouping" | "never" = "always";
  colDefs: ColDef<LogTrack>[] = [
    {
      field: 'brandName', headerName: 'Brand', rowGroup: true, hide: true, enableRowGroup: true,
      cellRenderer: (params: any) => {
        return `<a href="javascript:void(0)" style="color: blue; text-decoration: underline;">${params.value}</a>`;
      },
    },
    { field: 'UserName', headerName: 'User Name', enableRowGroup: true },
    { field: 'module', headerName: 'Module', enableRowGroup: true },
    { field: 'VisitDateTime', headerName: 'Visit Date Time', enableRowGroup: true },
    { field: 'appType', headerName: 'App Type', enableRowGroup: true },
    { field: 'appVersion', headerName: 'App Version', enableRowGroup: true },
    { field: 'eventType', headerName: 'Event Type', enableRowGroup: true },
    { field: 'deviceModel', headerName: 'Device Model', enableRowGroup: true },
    { field: 'eventMessage', headerName: 'Event Message', enableRowGroup: true },
    { field: 'platform', headerName: 'Plat Form', enableRowGroup: true },
    { field: 'UserId', headerName: 'User Id', enableRowGroup: true },
    { field: 'platformVersion', headerName: 'platformVersion' },
  ];

  //row intialization
  rowData: LogTrack[] = [];
  pinnedTopRowData: LogTrack[] = [];

  // default
  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: false,
    suppressHeaderMenuButton: true
  };

  autoGroupColumnDef: ColDef = {
    minWidth: 200,
  };

  logTrack() {
    this.spinner.show();
    this.log.getLogtracke().subscribe(
      {
        next: (res: any) => {
          if (!res) {
            this.spinner.hide();
            return;
          }
          this.rowData = res;
          this.spinner.hide();
        },
        error: (err: any) => {
          this.spinner.hide();
        }
      }
    )
  }

  stateColumns() {
    this.colDefs = [
      {
        field: 'brandName', headerName: 'Brand',
        cellRenderer: (params: any) => {
          if (params.node.rowPinned) {
            // Return plain text for pinned rows (no link)
            return `<span style="color: black; font-weight: bold;">${params.value}</span>`;
          }
          else {
            return `<a href="javascript:void(0)" style="color: blue; text-decoration: underline;">${params.value}</a>`;
          }
        },
      },
      {
        field: 'UserName', headerName: 'User Name',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',
      },
      {
        field: 'module', headerName: 'Module',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',

      },
      {
        field: 'VisitDateTime', headerName: 'Visit Date Time',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',

      },
      {
        field: 'appType', headerName: 'App Type',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',

      },
      {
        field: 'appVersion', headerName: 'App Version',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',

      },
      {
        field: 'eventType', headerName: 'Event Type',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',

      },
      {
        field: 'deviceModel', headerName: 'Device Model',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',

      },
      {
        field: 'eventMessage', headerName: 'Event Message',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',

      },
      {
        field: 'platform', headerName: 'Platform',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',

      },
      {
        field: 'UserId', headerName: 'User Id',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',

      },
      {
        field: 'platformVersion', headerName: 'Platform Version',
        cellStyle: { 'text-align': 'right' },
        headerClass: 'ag-right-aligned-header',

      }
    ];
  }

  setDate() {
    const dialogRef = this.dialog.open(LogTrackDialogComponent, {
      width: '40%',
      height: '100%',
      panelClass: ['custom-dialog-panel'],
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      disableClose: false,
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.log.postFilterLogSearch(result).subscribe(
          {
            next: (res: any) => {
              this.searchFilterList = res;
              this.rowData = this.searchFilterList;
              // console.log('searchFilterList', this.searchFilterList);
            },
            error: (err: any) => {

            }
          }
        );
        console.log('Received from dialog:', result);
      }
    })
  }



}
